<template>
    <div class="kgr-row">
        <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
            <div class="kgr-postfix__fluid">
                <kgr-icon
                    icon-class="list"
                    class="kgr-icon--big"
                    :class="showCalendar ? '':'kgr-icon--accent'"
                    style="cursor: pointer"
                    @click="changeView"
                />
                <kgr-icon
                    icon-class="calendar"
                    class="kgr-icon--big"
                    :class="showList ? '' : 'kgr-icon--accent'"
                    style="cursor: pointer"
                    @click="changeView"
                />
            </div>
            <div
                v-if="canCreateNew && createExamUrl"
                class="kgr-postfix__fixed"
            >
                <a
                    class="kgr-button kgr-button--accent"
                    :href="createExamUrl"
                >
                    <kgr-icon
                        icon-class="add"
                        small
                        circle
                        highlight
                        class="kgr-button__icon kgr-button__icon--left"
                    />
                    {{ $t('offering.exam.create') }}
                </a>
            </div>
            <div
                v-if="canCreateNew"
                class="kgr-postfix__fixed"
            >
                <a
                    class="kgr-button kgr-button--accent"
                    :href="createTrainingUrl"
                >
                    <kgr-icon
                        icon-class="add"
                        small
                        circle
                        highlight
                        class="kgr-button__icon kgr-button__icon--left"
                    />
                    {{ $t('offering.training.create') }}
                </a>
            </div>
            <div
                v-if="canCreateNew"
                class="kgr-postfix__fixed"
            >
                <a
                    class="kgr-button kgr-button--accent"
                    :href="createCourseUrl"
                >
                    <kgr-icon
                        icon-class="add"
                        small
                        circle
                        highlight
                        class="kgr-button__icon kgr-button__icon--left"
                    />
                    {{ $t('offering.course.create') }}
                </a>
            </div>
            <div
                v-if="canCreateNew"
                class="kgr-postfix__fixed"
            >
                <a
                    class="kgr-button kgr-button--accent"
                    :href="createGenericUrl"
                >
                    <kgr-icon
                        icon-class="add"
                        small
                        circle
                        highlight
                        class="kgr-button__icon kgr-button__icon--left"
                    />
                    {{ $t('offering.generic.create') }}
                </a>
            </div>
        </div>
        <div class="kgr-float kgr-float--clear kgr-row">
            <div class="kgr-float kgr-float--left kgr-float--inText">
                <div class="kgr-inputGroup">
                    <div
                        v-t="'offering.customerId'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <input
                        v-model="customerId"
                        type="text"
                        class="kgr-input"
                        @input="delayedSearch"
                    />
                </div>
            </div>
            <div class="kgr-float kgr-float--left kgr-float--inText">
                <div class="kgr-inputGroup">
                    <div
                        v-t="'offering.title'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <input
                        v-model="title"
                        type="text"
                        class="kgr-input"
                        :placeholder="placeholderTitle"
                        size="50"
                        @input="delayedSearch"
                    />
                </div>
            </div>

            <div class="kgr-float kgr-float--left kgr-float--inText">
                <div class="kgr-inputGroup">
                    <div
                        v-t="'offering.sports'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <kgr-multi-select
                        v-model="selectedSports"
                        :options="filteredSports"
                        searchable
                        @post-input="setPreFilter"
                    />
                </div>
            </div>
            <div class="kgr-float kgr-float--left kgr-float--inText">
                <div class="kgr-inputGroup">
                    <div
                        v-t="'offering.instructors'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <kgr-multi-select
                        v-model="selectedInstructors"
                        :options="filteredInstructors"
                        searchable
                        @post-input="setPreFilter"
                    />
                </div>
            </div>
            <div class="kgr-float kgr-float--left kgr-float--inText">
                <div class="kgr-inputGroup">
                    <div
                        v-t="'offering.offeringCategory'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <kgr-multi-select
                        v-model="selectedOfferingCategories"
                        :options="offeringCategoryOptions"
                        :inline="false"
                        searchable
                        @post-input="setPreFilter"
                    />
                </div>
            </div>
            <div class="kgr-float kgr-float--left kgr-float--inText">
                <div class="kgr-inputGroup">
                    <div
                        v-t="'offering.age'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <input
                        v-model.number="age"
                        type="text"
                        class="kgr-input"
                        style="width: 50px;"
                        @input="setPreFilter"
                    />
                </div>
            </div>
        </div>

        <div class="kgr-grid kgr-grid--full kgr-grid--medium-1of3 kgr-grid--gutters kgr-row">
            <div class="kgr-grid__cell">
                <div class="kgr-inputGroup">
                    <div
                        v-t="'offering.location'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <kgr-multi-select
                        v-model="selectedLocations"
                        :options="filteredLocations"
                        :inline="false"
                        searchable
                        @post-input="setLocation"
                    />
                </div>
            </div>
            <div class="kgr-grid__cell">
                <div
                    v-if="selectedLocations.length > 0 || selectedAreas.length > 0"
                    class="kgr-inputGroup"
                >
                    <div
                        v-t="'offering.areas'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <kgr-multi-select
                        v-model="selectedAreas"
                        display="label"
                        :options="filteredAreas"
                        :inline="false"
                        searchable
                        @post-input="setArea"
                    />
                </div>
            </div>
            <div class="kgr-grid__cell">
                <div
                    v-if="selectedAreas.length > 0 || selectedFields.length > 0"
                    class="kgr-inputGroup"
                >
                    <div
                        v-t="'offering.fields'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <kgr-multi-select
                        v-model="selectedFields"
                        :options="filteredFields"
                        :inline="false"
                        display="label"
                        searchable
                        @post-input="setPreFilter"
                    />
                </div>
            </div>
        </div>

        <div class="kgr-grid kgr-grid--full kgr-grid--medium-1of6 kgr-grid--gutters kgr-row">
            <div class="kgr-grid__cell">
                <div class="kgr-inputGroup">
                    <div
                        v-t="'offering.filter.date.start'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <date-picker @change="filterWithStartDate" />
                </div>
            </div>
            <div class="kgr-grid__cell">
                <div class="kgr-inputGroup">
                    <div
                        v-t="'offering.filter.date.end'"
                        class="kgr-inputGroup__label"
                    ></div>
                    <date-picker
                        :invalid="!isEndDateValide"
                        @change="filterWithEndDate"
                    />
                </div>
            </div>
        </div>

        <div class="kgr-row">
            <kgr-accordion>
                <kgr-accordion-item
                    :title="$t('offering.moreFilters') + ' (' + getMoreFiltersCount + ')'"
                >
                    <div class="kgr-grid kgr-grid--1of2 kgr-grid--large-1of4 kgr-grid--gutters">
                        <div class="kgr-grid__cell">
                            <div class="kgr-inputGroup">
                                <div
                                    v-t="'offering.weekday'"
                                    class="kgr-inputGroup__label"
                                ></div>
                                <kgr-weekday-multiselect
                                    v-model="selectedWeekdays"
                                    :inline="false"
                                    @post-input="setPreFilter"
                                />
                            </div>
                        </div>
                        <div class="kgr-grid__cell">
                            <kgr-multi-select
                                v-model="selectedDepartments"
                                :options="filteredDepartments"
                                :disabled="filterWithoutDepartment"
                                :label="$t('Abteilungen')"
                                :inline="false"
                                searchable
                                @post-input="setPreFilter"
                            />
                            <kgr-checkbox
                                :checked="filterWithoutDepartment"
                                :label="$t('offering.filterWithoutDepartment')"
                                @change="filterWithoutDepartmentChanged()"
                            />
                        </div>
                        <div class="kgr-grid__cell">
                            <kgr-multi-select
                                v-model="selectedTeams"
                                :options="filteredTeams"
                                :disabled="filterWithoutTeam"
                                :label="$t('Teams')"
                                :inline="false"
                                searchable
                                @post-input="setPreFilter"
                            />
                            <kgr-checkbox
                                :checked="filterWithoutTeam"
                                :label="$t('offering.filterWithoutTeam')"
                                @change="filterWithoutTeamChanged()"
                            />
                        </div>
                    </div>
                    <div class="kgr-grid kgr-grid--1of2 kgr-grid--large-1of4 kgr-grid--gutters">
                        <div class="kgr-grid__cell">
                            <div class="kgr-inputGroup">
                                <div
                                    v-t="'offering.gender'"
                                    class="kgr-inputGroup__label"
                                ></div>
                                <kgr-radio
                                    v-model="selectedGender"
                                    :options="genderOptions"
                                    :inline="true"
                                    @post-input="setPreFilter"
                                />
                            </div>
                        </div>
                        <div class="kgr-grid__cell">
                            <div class="kgr-inputGroup">
                                <div
                                    v-t="'offering.executionType'"
                                    class="kgr-inputGroup__label"
                                ></div>
                                <kgr-radio
                                    v-model="executionType"
                                    :options="executionTypes"
                                    :inline="true"
                                    @post-input="setPreFilter"
                                />
                            </div>
                        </div>
                        <div class="kgr-grid__cell">
                            <div class="kgr-inputGroup">
                                <div
                                    v-t="'offering.costs'"
                                    class="kgr-inputGroup__label"
                                ></div>
                                <kgr-radio
                                    v-model="selectedCost"
                                    :options="costFilterOptions"
                                    :inline="true"
                                    @post-input="setPreFilter"
                                />
                            </div>
                        </div>
                        <div class="kgr-grid__cell">
                            <div class="kgr-inputGroup">
                                <div
                                    v-t="'offering.others'"
                                    class="kgr-inputGroup__label"
                                ></div>
                                <kgr-radio
                                    v-model="selectedOthers"
                                    :options="otherFilterOptions"
                                    :inline="true"
                                    @post-input="setPreFilter"
                                />
                            </div>
                        </div>
                        <div class="kgr-grid__cell">
                            <div class="kgr-inputGroup">
                                <div
                                    v-t="'offering.waitList'"
                                    class="kgr-inputGroup__label"
                                ></div>
                                <kgr-radio
                                    v-model="selectedWaitListFilter"
                                    :options="waitListFilterOptions"
                                    :inline="true"
                                    @post-input="setPreFilter"
                                />
                            </div>
                        </div>
                        <div class="kgr-grid__cell">
                            <div class="kgr-inputGroup">
                                <div
                                    v-t="'offering.filter.memberContract'"
                                    class="kgr-inputGroup__label"
                                ></div>
                                <kgr-checkbox
                                    :checked="isBookableForActiveMembers !== true && isBookableForPassiveMembers !== true && isBookableForGuestMembers !== true"
                                    :label="$t('offering.filter.memberContract.all')"
                                    class="kgr-row kgr-row--smallMargin"
                                    @change="filterOfferingsForAllMembers()"
                                />
                                <kgr-checkbox
                                    :checked="isBookableForActiveMembers === true"
                                    :label="$t('offering.filter.memberContract.activeMembers')"
                                    class="kgr-row kgr-row--smallMargin"
                                    @change="filterOfferingsForActiveMembers()"
                                />
                                <kgr-checkbox
                                    :checked="isBookableForPassiveMembers === true"
                                    :label="$t('offering.filter.memberContract.passiveMembers')"
                                    class="kgr-row kgr-row--smallMargin"
                                    @change="filterOfferingsForPassiveMembers()"
                                />
                                <kgr-checkbox
                                    :checked="isBookableForGuestMembers === true"
                                    :label="$t('offering.filter.memberContract.guests')"
                                    class="kgr-row kgr-row--smallMargin"
                                    @change="filterOfferingsForGuestMembers()"
                                />
                            </div>
                        </div>
                    </div>
                </kgr-accordion-item>
            </kgr-accordion>
        </div>

        <div class="kgr-row">
            <div class="kgr-float--right">
                <kgr-button
                    :pending="excelDownloadPending"
                    @click="downloadExcel()"
                >
                    Excel-Download
                </kgr-button>
            </div>
        </div>

        <br />
        <div style="clear: both"></div>
        <br />
        <div
            v-if="showList"
        >
            <kgr-loading v-if="loading" />

            <div v-else>
                <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--bottom kgr-row">
                    <div class="kgr-postfix__fluid">
                        <div class="kgr-badge kgr-badge--info">
                            {{ meta && meta.pagination.total > 0 ? meta.pagination.total : '0' }} {{
                                $t('offering.hits')
                            }}
                        </div>
                    </div>
                    <div class="kgr-postfix__fixed">
                        <div class="kgr-inputGroup kgr-float--right">
                            <div
                                v-t="'offering.perpage'"
                                class="kgr-inputGroup__label"
                            ></div>
                            <kgr-generic-select
                                v-model="perPage"
                                :options="perPageSelect"
                                display="name"
                                inline
                                @post-input="updateMetaData"
                            />
                        </div>
                    </div>
                </div>
                <div class="kgr-row">
                    <kgr-offering-overview-list
                        :club-id="clubId"
                        :offerings="offerings"
                    />
                </div>
                <div
                    v-if="meta !== null && (meta.pagination.total > meta.pagination.count)"
                    class="kgr-grid__cell kgr-centered kgr-centered--vertically kgr-centered--horizontally"
                >
                    {{ $t('offering.moreHits') }}
                </div>
                <div>
                    <div class="kgr-inputGroup kgr-float--right">
                        <div
                            v-t="'offering.perpage'"
                            class="kgr-inputGroup__label"
                        ></div>
                        <kgr-generic-select
                            v-model="perPage"
                            :options="perPageSelect"
                            display="name"
                            inline
                            @post-input="updateMetaData"
                        />
                    </div>
                    <br />
                    <br />
                </div>
            </div>
        </div>
        <div
            v-show="showCalendar"
            class="kgr-row"
        >
            <div class="calendar-wrapper">
                <kgr-month-picker
                    v-if="calendarView === 'month' && calendarMonth"
                    :year="calendarMonth.year"
                    :month="calendarMonth.month"
                    inline
                    @change="setCalendarRange"
                />
                <div id="calendar"></div>
                <div
                    v-if="calendarLoading"
                    class="calendar-loading-overlay"
                >
                    <kgr-loading />
                </div>
            </div>
        </div>

        <kgr-generic-modal
            :value="!!(selectedStartDate && selectedEndDate)"
            headline="Angebot erstellen"
            @post-input="onCreateOfferingDialogClose"
        >
            <a
                :href="createTrainingUrl+'?'+ createOfferingQueryParams"
                class="kgr-button kgr-button--accent kgr-button--block kgr-row"
            >
                Training
            </a>
            <a
                :href="createCourseUrl+'?'+ createOfferingQueryParams"
                class="kgr-button kgr-button--accent kgr-button--block kgr-row"
            >
                Kurs
            </a>
            <a
                :href="createGenericUrl+'?'+ createOfferingQueryParams"
                class="kgr-button kgr-button--accent kgr-button--block"
            >
                Angebot
            </a>
        </kgr-generic-modal>
    </div>
</template>

<script>
import { h, markRaw } from 'vue';
import Accordion from '../../components/common/accordion/Accordion';
import AccordionItem from '../../components/common/accordion/AccordionItem';
import AppointmentRepository from '../../js/repository/AppointmentRepository';
import Checkbox from '../../components/common/form/checkbox/Checkbox';
import DatePicker from '../../components/common/form/picker/DatePicker.vue';
import DepartmentRepository from '../../js/repository/club/offering/OfferingDepartmentRepository';
import GenericModal from '../../components/common/modal/GenericModal';
import GenericRadio from '../../components/common/form/radio/GenericRadio';
import GenericSelect from '../../components/common/form/select/GenericSelect';
import Icon from '../../components/common/icon/Icon';
import InstructorRepository from '../../js/repository/InstructorRepository';
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import Loading from '../../components/common/Loading';
import LocationRepository from '../../js/repository/LocationRepository';
import MonthPicker from '@legacy/components/common/form/picker/MonthPicker.vue';
import MultiSelect from '../../components/common/form/select/MultiSelect';
import Offering from '../../js/dto/offering/Offering';
import OfferingCategoryRepository from '../../js/repository/club/offering/OfferingCategoryRepository';
import OfferingOverviewList from '../../components/offering/OfferingOverviewList';
import OfferingRepository from '../../js/repository/club/offering/OfferingRepository';
import SportsRepository from '../../js/repository/SportsRepository';
import TeamRepository from '../../js/repository/club/offering/OfferingTeamRepository';
import WeekdayMultiSelect from '../../components/common/form/select/WeekdayMultiSelect';
import moment from 'moment';

const HIDE_EXPIRED_BOOKINGS = 0;
const SHOW_EXPIRED_BOOKINGS = 1;
const SHOW_ARCHIVED_BOOKINGS = 2;

const DEFAULT_CATEGORY_COURSE = 'course';
const DEFAULT_CATEGORY_EXAM = 'exam';
const DEFAULT_CATEGORY_TRAINING = 'training';
const DEFAULT_CATEGORIES = [DEFAULT_CATEGORY_COURSE, DEFAULT_CATEGORY_EXAM, DEFAULT_CATEGORY_TRAINING];

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-loading': Loading,
        'kgr-checkbox': Checkbox,
        'kgr-offering-overview-list': OfferingOverviewList,
        'kgr-weekday-multiselect': WeekdayMultiSelect,
        'kgr-generic-select': GenericSelect,
        'kgr-multi-select': MultiSelect,
        'kgr-icon': Icon,
        'kgr-accordion': Accordion,
        'kgr-accordion-item': AccordionItem,
        'kgr-radio': GenericRadio,
        'kgr-generic-modal': GenericModal,
        'date-picker': DatePicker,
        'kgr-month-picker': MonthPicker,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        createGenericUrl: {
            type: String,
            required: true,
        },
        createCourseUrl: {
            type: String,
            required: true,
        },
        createTrainingUrl: {
            type: String,
            required: true,
        },
        createExamUrl: {
            type: String,
            required: false,
            default: null,
        },
        canCreateNew: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            calendarView: null,
            calendarMonth: null,
            loading: false,
            calendarLoading: false,
            offerings: [],
            selectedWeekdays: [],
            selectedSports: [],
            selectedLocations: [],
            fields: [],
            selectedTempLocations: [],
            selectedAreas: [],
            selectedTempAreas: [],
            selectedFields: [],
            selectedDepartments: [],
            selectedTeams: [],
            selectedInstructors: [],
            sportslist: [],
            instructors: [],
            fullLocations: [],
            fullAreas: [],
            departmentlist: [],
            teamlist: [],
            meta: null,
            title: null,
            customerId: null,
            executionType: null,
            selectedCost: null,
            selectedOthers: HIDE_EXPIRED_BOOKINGS,
            selectedWaitListFilter: null,
            placeholderTitle: this.$t('offering.pleaseFillIn'),
            locations: [],
            offeringCategories: [],
            selectedOfferingCategories: [],
            selectedStartDate: null,
            selectedEndDate: null,
            perPageSelect: [
                {'name': 5, 'id': 5},
                {'name': 20, 'id': 20},
                {'name': 50, 'id': 50},
                {'name': 100, 'id': 100},
                {'name': 250, 'id': 250},
                {'name': 500, 'id': 500}
            ],
            executionTypes: {
                'offering.all': null,
                'offering.presence': Offering.EXECUTION_TYPE_PRESENCE,
                'offering.hybrid': Offering.EXECUTION_TYPE_HYBRID,
                'offering.online': Offering.EXECUTION_TYPE_ONLINE,
            },
            genderOptions: {
                'offering.all': null,
                'offering.mixed': 0,
                'offering.onlyWomen': 2,
                'offering.onlyMen': 1,
            },
            costFilterOptions: {
                'offering.all_prices': null,
                'offering.price_free': true,
                'offering.price_chargeable': false,
            },
            otherFilterOptions: {
                'offering.showExpiredOffering.true': SHOW_EXPIRED_BOOKINGS,
                'offering.showExpiredOffering.false': HIDE_EXPIRED_BOOKINGS,
                'offering.showArchivedOfferings': SHOW_ARCHIVED_BOOKINGS,
            },
            waitListFilterOptions: {
                'offering.filter.waitList.all': null,
                'offering.filter.waitList.active': true,
                'offering.filter.waitList.deactivated': false,
            },
            selectedGender: null,
            calendarEvents: [],
            age: null,
            perPage: {'name': 20, 'id': 20},
            page: 1,
            showCalendar: false,
            showList: true,
            filterWithoutTeam: false,
            filterWithoutDepartment: false,
            timeout: null,
            excelDownloadPending: false,
            isBookableForActiveMembers: null,
            isBookableForPassiveMembers: null,
            isBookableForGuestMembers: null,
            filterStartDate: null,
            filterEndDate: null,
        }
    },
    computed: {
        getMoreFiltersCount() {
            let count = 0;
            count += this.selectedWeekdays.length;
            count += this.selectedDepartments.length;
            count += this.selectedTeams.length;
            if ((this.bookableForMen || this.bookableForWomen)) {
                count++;
            }
            if (this.selectedCost != null) {
                count++;
            }
            if (this.selectedOthers !== SHOW_EXPIRED_BOOKINGS) {
                count++;
            }
            if (this.selectedWaitListFilter != null) {
                count++;
            }
            if (this.executionType && this.executionType.length > 0) {
                count++;
            }
            if (this.isBookableForActiveMembers !== null ||
                this.isBookableForPassiveMembers !== null ||
                this.isBookableForGuestMembers !== null) {
                count++;
            }
            return count;
        },
        bookableForMen() {
            if(this.selectedGender === 0 || this.selectedGender === 1) {
                return true;
            }
            if(this.selectedGender === 2) {
                return false;
            }
            return null;
        },
        bookableForWomen() {
            if(this.selectedGender === 0 || this.selectedGender === 2) {
                return true;
            }
            if(this.selectedGender === 1) {
                return false;
            }
            return null;
        },
        filteredInstructors() {
            return this.instructors.filter(instructor => {
                return this.selectedInstructors.find(selectedInstructor => selectedInstructor.value === instructor.value) === undefined
            });
        },
        filteredSports() {
            return this.sportslist.filter(sport => {
                return this.selectedSports.find(selectedSport => selectedSport.value === sport.value) === undefined
            });
        },
        filteredLocations() {
            return this.locationsSelect.filter(location => {
                return this.selectedLocations.find(selectedLocation => selectedLocation.value === location.value) === undefined
            });
        },
        filteredAreas() {
            const result = [];
            let locations = Array.from(this.fullLocations);
            this.selectedTempLocations.forEach(location => {
                const fullLocation = locations.find(fullLocation => fullLocation.id === location.value);
                fullLocation.areas.forEach(area => {
                    if ((this.selectedAreas.findIndex(selectedArea => selectedArea.value === area.id) === -1)) {
                        result.push({
                            'label': area.hierarchyPath + ' / ' + area.name,
                            'value': area.id,
                            'hierarchyPath': area.hierarchyPath,
                        }
                        );
                    }
                    this.fullAreas.push(area);
                });
            });
            return result;
        },
        filteredFields() {
            const result = [];
            let areas = Array.from(this.fullAreas);
            this.selectedTempAreas.forEach(area => {
                const fullArea = areas.find(fullArea => fullArea.id === area.value);
                fullArea.fields.forEach(field => {
                    if ((this.selectedFields.findIndex(selectedField => selectedField.value === field.id) === -1)) {
                        result.push({
                            'label': field.hierarchyPath + ' / ' + field.name,
                            'value': field.id,
                            'hierarchyPath': field.hierarchyPath,
                        }
                        );
                    }
                }
                )
            });
            return result;
        },
        filteredDepartments() {
            return this.departmentlist.filter(department => {
                return this.selectedDepartments.find(selectedDepartment => selectedDepartment.value === department.value) === undefined
            });
        },
        filteredTeams() {
            return this.teamlist.filter(team => {
                return this.selectedTeams.find(selectedTeam => selectedTeam.value === team.value) === undefined
            });
        },
        createOfferingQueryParams() {
            if (this.selectedStartDate && this.selectedEndDate) {
                return `start=${encodeURIComponent(this.selectedStartDate.toISOString())}&end=${encodeURIComponent(this.selectedEndDate.toISOString())}`;
            }
            return '';
        },
        locationsSelect() {
            return this.fullLocations.map((location) => {return {'label': location.name, 'value': location.id};});
        },
        offeringCategoryOptions() {
            return this.offeringCategories.map(category => {
                return {
                    'value': category.id,
                    'label': DEFAULT_CATEGORIES.includes(category.name) ? this.$t(category.name) : category.name
                };
            })
        },
        inBookableTeamsFilter() {
            if(this.filterWithoutTeam) {
                return [];
            }
            return this.selectedTeams.map(team => team.value);
        },
        inBookableDepartmentsFilter() {
            if(this.filterWithoutDepartment) {
                return [];
            }
            return this.selectedDepartments.map(department => department.value);
        },
        inAreasFilter() {
            let areas = this.selectedAreas;
            this.selectedFields.forEach(field => {
                areas = areas.filter(area => area.label !== field.hierarchyPath);
            });
            return areas.map(area => area.value);
        },
        inLocationsFilter() {
            let locations = this.selectedLocations;
            this.selectedAreas.forEach(area => {
                locations = locations.filter(location => location.label !== area.hierarchyPath);
            });
            return locations.map(location => location.value);
        },
        filter() {
            let filters = {
                onWeekdays: this.selectedWeekdays.map(weekday => weekday.value),
                inSports: this.selectedSports.map(sport => sport.value),
                inFields: this.selectedFields.map(field => field.value),
                inAreas: this.inAreasFilter,
                inLocations: this.inLocationsFilter,
                inOfferingCategories: this.selectedOfferingCategories.map(category => category.value),
                withInstructors: this.selectedInstructors.map(instructor => instructor.value),
                inBookableTeams: this.inBookableTeamsFilter,
                inBookableDepartments: this.inBookableDepartmentsFilter,
                withoutBookableTeams: this.filterWithoutTeam,
                withoutBookableDepartments: this.filterWithoutDepartment,
                executionTypes: this.executionType ? [this.executionType] : [],
                withTermInTitle:  this.title,
                isBookableForMen: this.bookableForMen,
                isBookableForWomen: this.bookableForWomen,
                forAge: this.age,
                customerId: this.customerId,
                isFree: this.selectedCost,
                withWaitList: this.selectedWaitListFilter,
                isBookableForActiveMembers: this.isBookableForActiveMembers,
                isBookableForPassiveMembers: this.isBookableForPassiveMembers,
                isBookableForGuestMembers: this.isBookableForGuestMembers,
                from: this.filterStartDate,
                to: this.filterEndDate,
            }
            if (this.selectedOthers !== SHOW_ARCHIVED_BOOKINGS) {
                filters.showExpiredOfferings = this.selectedOthers === SHOW_EXPIRED_BOOKINGS;
            } else {
                filters.withArchived = true;
            }
            return filters;
        },
        isEndDateValide() {
            if (this.filterStartDate === null) {
                return true;
            }

            if (this.filterEndDate === null) {
                return true;
            }

            return moment(this.filterStartDate, 'YYYY-MM-DD').isSameOrBefore(moment(this.filterEndDate, 'YYYY-MM-DD'));
        },
    },
    created() {
        SportsRepository.findAll(this.clubId)
            .then(sports => sports.forEach(sport => this.sportslist.push({'label': sport.name, 'value': sport.id})))
            .catch(() => this.$notify.error('error.loadingData'));
        LocationRepository.findAllByClubId(this.clubId)
            .then(locations => {
                this.fullLocations = locations;
            })
            .catch(() => this.$notify.error('error.loadingData'));
        DepartmentRepository.findAll(this.clubId, true)
            .then(departments => {
                departments.sort((a, b) => (a.departmentName + ' / ' + a.name).toLowerCase().localeCompare((b.departmentName + ' / ' + b.name).toLowerCase()));
                departments.forEach(department => {
                    this.departmentlist.push({
                        'label': department.name,
                        'value': department.id
                    });
                    this.getChildDepartments(department);
                })
            })
            .catch(() => this.$notify.error('error.loadingData'));
        TeamRepository.findAll(this.clubId, true)
            .then(teams => {
                teams.sort((a, b) => (a.departmentName + ' / ' + a.name).toLowerCase().localeCompare((b.departmentName + ' / ' + b.name).toLowerCase()));
                teams.forEach(team => this.teamlist.push({
                    'label': team.departmentName + ' / ' + team.name,
                    'value': team.id
                }))
            })
            .catch(() => this.$notify.error('error.loadingData'));

        InstructorRepository.findAllByClub(this.clubId, true)
            .then(instructors => {
                instructors.sort((a, b) => (a.fullName).toLowerCase().localeCompare((b.fullName).toLowerCase()));
                instructors.forEach(instructor => this.instructors.push({
                    'label': instructor.fullName,
                    'value': instructor.id
                }))
            })
            .catch(() => this.$notify.error('error.loadingData'));

        OfferingCategoryRepository.findAllWithDefaultsAndArchived(this.clubId)
            .then(categories => this.offeringCategories = categories)
            .catch(() => this.$notify.error('error.loadingData'));

        this.findAllAndGetMeta(this.filter, this.perPage);
    },
    methods: {
        onCalendarChange(view) {
            this.calendarView = view.name;
            if(this.calendarView === 'month') {
                this.calendarMonth = {year: view.start.getFullYear(), month: view.start.getMonth() + 1}
            }
            else {
                this.calendarMonth = null;
            }

            if (this.calendarLoading) {
                return;
            }

            const firstDay = moment(view.start).format('YYYY-MM-DD');
            const lastDay = moment(view.end).subtract(1, 'day').format('YYYY-MM-DD');
            this.loadCalendarAppointments(this.filter, firstDay, lastDay);
        },
        setCalendarRange(date) {
            // date is {month: number, year: number}
            const targetDate = new Date(date.year, date.month - 1, 1);
            $('#calendar').fullCalendar('gotoDate', targetDate);
        },
        filterWithoutDepartmentChanged() {
            this.filterWithoutDepartment = !this.filterWithoutDepartment;
            this.selectedDepartments = [];
            this.setPreFilter();
        },
        filterWithoutTeamChanged() {
            this.filterWithoutTeam = !this.filterWithoutTeam;
            this.selectedTeams = [];
            this.setPreFilter();
        },
        getChildDepartments(department) {
            department.childDepartments.sort((a, b) => ((a.name).toLowerCase() < (b.name).toLowerCase()) ? -1 : ((a.name).toLowerCase() > (b.name).toLowerCase()) ? 1 : 0);
            department.childDepartments.forEach(childDepartment => {
                this.departmentlist.push({
                    'label': childDepartment.hierarchyPath + ' / ' + childDepartment.name,
                    'value': childDepartment.id
                });
                this.getChildDepartments(childDepartment);
            });
        },
        setLocation() {
            this.selectedTempLocations = this.selectedLocations;
            this.selectedAreas = this.selectedAreas.filter((area) => this.selectedLocations.map(l => l.label).includes(area.hierarchyPath));
            this.setArea()
        },
        setArea() {
            this.selectedTempAreas = this.selectedAreas;
            this.selectedFields = this.selectedFields.filter((field) => this.selectedAreas.map(a => a.label).includes(field.hierarchyPath));
            this.setPreFilter();
        },
        setPreFilter() {
            if (this.showCalendar) {
                const calendarView = $('#calendar').fullCalendar('getView');
                let from, to;
                if (calendarView && calendarView.start) {
                    from = moment(calendarView.start).format('YYYY-MM-DD');
                    to = moment(calendarView.end).subtract(1, 'day').format('YYYY-MM-DD');
                } else {
                    from = moment().subtract(3, 'month').format('YYYY-MM-DD');
                    to = moment().add(9, 'month').format('YYYY-MM-DD');
                }
                this.loadCalendarAppointments(this.filter, from, to);
            } else {
                this.findAllAndGetMeta(this.filter, this.perPage);
            }
        },
        loadCalendarAppointments(filters, from, to) {
            this.calendarLoading = true;
            return AppointmentRepository.findByFilter(this.clubId, from, to, filters)
                .then(appointments => {
                    this.calendarEvents = appointments.map(appointment => ({
                        title: appointment.offeringTitle,
                        start: appointment.start.date,
                        end: appointment.end.date,
                        backgroundColor: appointment.backgroundColor,
                        url: this.getViewRouteNameByCategory(appointment),
                        allDay: false
                    }));
                    $('#calendar').fullCalendar('removeEvents');
                    $('#calendar').fullCalendar('addEventSource', this.calendarEvents);
                })
                .finally(() => {
                    this.calendarLoading = false;
                });
        },
        changeView() {
            this.showCalendar = !this.showCalendar;
            this.showList = !this.showList;
            if (this.showCalendar) {
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        this.initCalendar([]);
                    });
                });
            }
        },
        getViewRouteNameByCategory(appointment) {
            if (appointment.offeringCategory === 'course') {
                return `/backend/clubs/${this.clubId}/course-offerings/${appointment.offeringId}/view`;
            } else if (appointment.offeringCategory === 'training') {
                return `/backend/clubs/${this.clubId}/training-offerings/${appointment.offeringId}/view`;
            } else {
                return `/backend/clubs/${this.clubId}/generic-offerings/${appointment.offeringId}/view`;
            }
        },
        updateMetaData() {
            this.findAllAndGetMeta(this.filter, this.perPage);
        },
        onCreateOfferingDialogClose() {
            this.selectedStartDate = null;
            this.selectedEndDate = null;
        },
        findAllAndGetMeta(filter, perPage) {
            this.loading = true;
            OfferingRepository.findAllAndGetMeta(this.clubId, filter, perPage, 1)
                .then(data => {
                    this.meta = data.meta;
                    this.offerings = data.data.map((data) => Offering.fromData(data));
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        initCalendar(appointments) {
            const component = this;
            const options = {
                events: appointments,
                header: {
                    left: 'prev,next,today',
                    center: 'title',
                    right: 'month, agendaWeek, agendaDay'
                },
                allDaySlot: false,
                buttonText: {
                    prev: '&nbsp;&#9668;&nbsp;',
                    next: '&nbsp;&#9658;&nbsp;',
                    prevYear: '&nbsp;&lt;&lt;&nbsp;',
                    nextYear: '&nbsp;&gt;&gt;&nbsp;',
                    today: 'Heute',
                    month: 'Monat',
                    week: 'Woche',
                    day: 'Tag',
                },
                firstDay: 1,
                weekMode: 'liquid',
                timeFormat: 'HH:mm',
                axisFormat: 'HH:mm',
                slotMinutes: 30,
                firstHour: 8,
                minTime: 6,
                maxTime: 24,
                monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                dayNamesShort: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
                dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                defaultView: 'agendaWeek',
                selectable: true,
                selectHelper: true,
                select: component.onCalendarSelect.bind(component),
                viewRender: function(view) {
                    component.onCalendarChange(view);
                },
            };
            $('#calendar').fullCalendar(options);
        },
        onCalendarSelect(startDate, endDate, allDay) {
            if (!allDay) {
                this.selectedStartDate = startDate;
                this.selectedEndDate = endDate;
            }
        },
        delayedSearch() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(() => {
                this.setPreFilter();
            }, 1000);
        },
        downloadExcel() {
            this.excelDownloadPending = true;
            OfferingRepository.downloadExcel(this.clubId, this.filter)
                .catch(error => {
                    const offeringId = error?.messageForField('offeringId');
                    const offeringTitle = error?.messageForField('offeringTitle');
                    if (offeringId && offeringTitle) {
                        const offeringCustomId = error?.messageForField('offeringCustomId');
                        const offeringCategory = error?.messageForField('offeringCategory');
                        const description = offeringCustomId
                            ? this.$t(
                                'Das Angebot "{title}" (Angebots-ID: {customId}) hat ein ungültiges Intervallende. Bitte aktualisiere das Angebot.',
                                { title: offeringTitle, customId: offeringCustomId },
                            )
                            : this.$t(
                                'Das Angebot "{title}" hat ein ungültiges Intervallende. Bitte aktualisiere das Angebot.',
                                { title: offeringTitle },
                            );
                        const url = this.buildOfferingEditUrl({ id: offeringId, offeringCategory: { name: offeringCategory } });
                        this.$notify.error('Der Excel-Export konnte nicht erstellt werden.', {}, {
                            description: markRaw(h('div', [
                                h('span', description),
                                h('br'),
                                h('a', { href: url }, '→ ' + this.$t('Zum Angebot wechseln')),
                            ])),
                        });
                    } else {
                        this.$notify.error('error.loadingData');
                    }
                })
                .finally(() => {
                    this.excelDownloadPending = false;
                });
        },
        buildOfferingEditUrl(offering) {
            const category = offering.offeringCategory?.name;
            if (category === 'course') {
                return `/backend/clubs/${this.clubId}/course-offerings/${offering.id}/edit`;
            } else if (category === 'training') {
                return `/backend/clubs/${this.clubId}/training-offerings/${offering.id}/edit`;
            } else if (category === 'exam') {
                return `/backend/clubs/${this.clubId}/exam-offerings/${offering.id}/edit`;
            }
            return `/backend/clubs/${this.clubId}/generic-offerings/${offering.id}/edit`;
        },
        filterOfferingsForActiveMembers() {
            if (this.isBookableForActiveMembers === null) {
                this.isBookableForActiveMembers = true;
            } else {
                this.isBookableForActiveMembers = null;
            }
            this.setPreFilter();
        },
        filterOfferingsForPassiveMembers() {
            if (this.isBookableForPassiveMembers === null) {
                this.isBookableForPassiveMembers = true;
            } else {
                this.isBookableForPassiveMembers = null;
            }
            this.setPreFilter();
        },
        filterOfferingsForGuestMembers() {
            if (this.isBookableForGuestMembers === null) {
                this.isBookableForGuestMembers = true;
            } else {
                this.isBookableForGuestMembers = null;
            }
            this.setPreFilter();
        },
        filterOfferingsForAllMembers() {
            this.isBookableForActiveMembers = null;
            this.isBookableForPassiveMembers = null;
            this.isBookableForGuestMembers = null;
            this.setPreFilter();
        },
        filterWithStartDate(date) {
            const start = moment(date, 'DD.MM.YYYY');
            if (start.isValid()) {
                this.filterStartDate = start.format('YYYY-MM-DD');
            } else {
                this.filterStartDate = null;
            }
            this.setPreFilter();
        },
        filterWithEndDate(date) {
            const end = moment(date, 'DD.MM.YYYY');
            if (end.isValid()) {
                this.filterEndDate = end.format('YYYY-MM-DD');
            } else {
                this.filterEndDate = null;
            }
            this.setPreFilter();
        }
    },
}

</script>

<style scoped lang="scss" rel="stylesheet/scss">
.calendar-wrapper {
    position: relative;
}

.calendar-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--kgr-loading-container-blocking-background, rgba(255, 255, 255, 0.7));
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}
</style>
